import React, { useEffect } from 'react'
import Heading from '../../components/Heading'
import AsyncSelect from 'react-select/async'
import productModel from "../../models/products.model";
import userModel from '../../models/user.model'
import orderModel from '../../models/orders.model'
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import helper from '../../lib/helper';
import useSWR from 'swr'
import _ from 'lodash';
import { Card } from 'react-bootstrap';
import ordersModel from '../../models/orders.model';
import { useRouter } from 'next/router';


const page = () => {
    const [mobile, setMobile] = useState('');
    const [searchString, setSearchString] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const [mobileoption, setmobileOption] = useState([])
    const [userDetails, setUserDetails] = useState([])
    const [productDetails, setProductDetails] = useState([])
    const [address, setAddress] = useState([])
    const [selectedAddress, setSelectedAddress] = useState(null)
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedCardId, setSelectedCardId] = useState(null);
    const [selectedProductId, setSelectedProductId] = useState(null)
    
    const router= useRouter();
    
    const {
        register,
        setValue,
        handleSubmit,
        watch,
        reset,
        formState: { errors,isSubmitting },
        setError,
    } = useForm();

    useEffect(() => {

        reset(selectedAddress);
    }, [selectedAddress])

    useEffect(() => {
        reset(selectedProduct);
        setValue('amount', selectedProduct?.selling_price);
        setValue('payment_status', 'pending')
    }, [selectedProduct])



    const loadOptionsProductSku = async (inputValue,status) => {
        if (inputValue === '') {
            return [];
        }

        try {
            setIsLoading(true);

            // Make an API call to fetch data based on inputValue
            const response = await productModel.list({ sku: inputValue,status:'publish'})
            const data = response
            // Transform the response data into options format (label and value)
            const options = response?.data?.map((item) => ({
                label: item.sku,
                value: item.id,
            })) || [];

            setProductDetails(data)
            setOptions(options);

        } catch (error) {
            // Handle any errors that occurred during the API call
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false);
        }
    };
    const fetchAddressData = async (userIds) => {
        const addressData = await userModel.address(userIds || 'null');
        setAddress(addressData);
    };
    const loadOptionsMobile = async (inputValue) => {
        if (inputValue === '') {
            return [];
        }

        try {
            setIsLoading(true);


            const response = await userModel.list({ mobile: inputValue });

            if (response.data && response.data.length > 0) {
                // Extract user IDs from the response
                const userIds = response.data.map((user) => user.id);
                // Fetch address data based on user IDs
                fetchAddressData(userIds || []);
            } else {
                // Handle the case where no user is found for the mobile number
                // You can set appropriate state or display a message to the user
                // For example:

                setAddress([]); // Clear address data
            }
            // Transform the response data into options format (label and value)
            const options = response?.data?.map((item) => ({
                label: item.sku,
                value: item.id,
            })) || [];
            setUserDetails(response)
            setmobileOption(options)

        } catch (error) {
            // Handle any errors that occurred during the API call
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false);
        }
    };
    const handleSearchButtonClickmobile = () => {
        // Manually trigger the search when the button is clicked
        loadOptionsMobile(mobile)
    }
    const handleSearchButtonClickproductSku = () => {
        // Manually trigger the search when the button is clicked
        loadOptionsProductSku(searchString);
    };

    const onCardClick = (addressData) => {
        setSelectedAddress(addressData);
        setSelectedCardId(addressData.id);
    };

    const onProductCardClick = (productData) => {
        setSelectedProduct(productData);
        setSelectedProductId(productData?.id)
    };
    const onSubmit = handleSubmit(async (data, event) => {

        const formData = new FormData(event.target);

        await ordersModel
            .create(formData)
            .then((response) => {
                console.log(response)
                console.log(response?.data?.message)
                helper.sweetalert.toast(response?.data?.message)
                router.push("/orders");
            })
            .catch((error) => {
                // console.log(error.response.data.errors);
                helper.sweetalert.toast(error.response?.data?.message, 'error');
                _.each(error.response?.data?.errors, function (err, errorKey) {
                    setError(errorKey, { type: "required", message: err });
                });
            });
    });
    return (
        <>
            <Heading title="Create new order">
            </Heading>
            <div className='container-fluid row'>
                <div className='col-md-6 p-3 border-1'>
                    <form>
                        <label className='form-label'>Mobile number</label>
                        <input
                            className={`form-control`}
                            type="text"
                            placeholder="Search mobile"
                            value={mobile}
                            onChange={(e) => setMobile(e.target.value)}
                        />
                        <label className='form-label'>Product SKU</label>
                        <input
                            className='form-control'
                            type="text"
                            placeholder="Search SKU"
                            value={searchString}
                            onChange={(e) => setSearchString(e.target.value)}
                        />

                      {/* <label className='form-label'>Remark</label>
                        <input
                            className='form-control'
                            type="text"
                            {...register('remark')}
                        /> */}
                        <button type='button' className='btn btn-primary btn-sm float-end mt-2' onClick={() => { handleSearchButtonClickproductSku(), handleSearchButtonClickmobile() }}>Search</button>
                    </form>
                    <div>
                    </div>
                    
                    
                    
                    
                    
                    <h4 className='mt-5 text-decoration-underline'>Address Details</h4>
                    {address?.data?.map((address) => {

                        return (

                            <Card className={`mt-2 ${selectedCardId === address.id ? 'border-primary' : ''}`} onClick={() => onCardClick(address)}>
                                <Card.Body>
                                    <span>{address?.name},</span>
                                    <span>{address?.mobile},</span>
                                    <span>{address?.line_1},</span>
                                    <span>{address?.line_2},</span>
                                    <span>{address?.locality},</span>
                                    <span>{address?.pincode},</span>
                                    <span>{address?.city},</span>
                                    <span>{address?.state}</span>
                                </Card.Body>
                            </Card>
                        )
                    })}
                    <h4 className='mt-3 text-decoration-underline'>Product Details</h4>
                    {productDetails?.data?.map((pd) => {

                        return (
                            <Card className={`mt-2 ${selectedProductId === pd.id ? 'border-primary' : ''}`} onClick={() => onProductCardClick(pd)}>
                                <Card.Body>
                                    <img src={pd?.thumbnail} height='100px' />
                                    {/* <h6><span className='text-decoration-underline'>Description</span>: {pd?.description}</h6> */}
                                    <h6><span className='text-decoration-underline'>Selling-Price</span>: {pd?.selling_price}</h6>
                                    <h6><span className='text-decoration-underline'>Qty</span>: {pd?.quantity}</h6>
                                    <h6><span className='text-decoration-underline'>SKU</span>: {pd?.sku}</h6>
                                    <h6><span className='text-decoration-underline'>Weight</span>: {pd?.weight}</h6>
                                    <h6><span className='text-decoration-underline'>Country_origin</span>: {pd?.country_origin}</h6>
                                </Card.Body>

                            </Card>)
                    })}
                </div>
                <div className='col-md-6 p-3'>
                    <form onSubmit={onSubmit}>
                        <div>

                            <input type='hidden' {...register('user_id')} value={userDetails?.data?.map((ud) => {
                                return (
                                    ud?.id
                                )
                            })} />
                            <label className='form-label'>Name</label>
                            <input type="text" className={`form-control ${errors?.name && 'is-invalid'}`}{...register('name', {
                                required: true
                            })} />
                            <div className="invalid-feedback">
                                {errors.name && errors.name.message}
                            </div>
                            <label className='form-label'>Mobile</label>
                            <input type="number" className={`form-control ${errors?.mobile && 'is-invalid'}`} {...register('mobile', {
                                required: true
                            })} />
                            <div className="invalid-feedback">
                                {errors.mobile && errors.mobile.message}
                            </div>
                            <label className='form-label'>Address Line 1</label>
                            <input type="text" className={`form-control ${errors?.line_1 && 'is-invalid'}`} {...register('line_1', {
                                required: true
                            })} />
                            <div className="invalid-feedback">
                                {errors.line_1 && errors.line_1.message}
                            </div>
                            <label className='form-label'>Address Line 2</label>
                            <input type="text" className={`form-control ${errors?.line_2 && 'is-invalid'}`} {...register('line_2', {

                                required: true
                            })} />
                            <div className="invalid-feedback">
                                {errors.line_2 && errors.line_2.message}
                            </div>
                            <label className='form-label'>Locality</label>
                            <input type="text" className={`form-control ${errors?.locality && 'is-invalid'}`} {...register('locality', { required: true })} />
                            <div className="invalid-feedback">
                                {errors.locality && errors.locality.message}
                            </div>
                            <label className='form-label'>Pincode</label>
                            <input type="text" className={`form-control ${errors?.pincode && 'is-invalid'}`}{...register('pincode', { required: true })} />
                            <div className="invalid-feedback">
                                {errors.pincode && errors.pincode.message}
                            </div>
                            <label className='form-label'>City</label>
                            <input type="text" className={`form-control ${errors?.city && 'is-invalid'}`} {...register('city', { required: true })} />
                            <div className="invalid-feedback">
                                {errors.city && errors.city.message}
                            </div>
                            <label className='form-label'>State</label>
                            <input type="text" className={`form-control ${errors?.state && 'is-invalid'}`} {...register('state', { required: true })} />
                            <div className="invalid-feedback">
                                {errors.state && errors.state.message}
                            </div>
                        </div>
                        <span>
                            <label className='form-label'>Amount</label>
                            <input type="text" className={`form-control ${errors?.amount && 'is-invalid'}`} {...register('amount', { required: true })} />
                            <div className="invalid-feedback">
                                {errors.amount && errors.amount.message}
                            </div>
                            <label className='form-label'>MRP</label>
                            <input type="text" className={`form-control ${errors?.mrp && 'is-invalid'}`} {...register('mrp', { required: true })} />
                            <div className="invalid-feedback">
                                {errors.mrp && errors.mrp.message}
                            </div>
                            <label className='form-label'>Status</label>
                            <input type="text" className={`form-control ${errors?.status && 'is-invalid'}`} {...register('status', { required: true })} />
                            <div className="invalid-feedback">
                                {errors.status && errors.status.message}
                            </div>
                            <label className='form-label'>Payment status</label>
                            <input type="text" className={`form-control ${errors?.payment_status && 'is-invalid'}`} {...register('payment_status', { required: true })} />
                            <div className="invalid-feedback">
                                {errors.payment_status && errors.payment_status.message}
                            </div>
                            <label className='form-label'>Payment_mode</label>
                            <select className={`form-select ${errors?.payment_mode && 'is-invalid'}`}{...register('payment_mode', { required: true })}>
                                <option value='cod'>cod</option>
                                <option value='online'>online</option>
                            </select>
                            <div className="invalid-feedback">
                                {errors.payment_mode && errors.payment_mode.message}
                            </div>
                        </span>
                        <button type="submit" disabled={isSubmitting ? 'disabled' : ''} className='btn btn-sm btn-primary float-end mt-2'>Submit</button>
                    </form>
                </div>
            </div>
        </>
    )
}

export default page


